<template>
    <div>
        <div class="leaderBox" v-if="showOrhide"> 
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/addxnwl.png" class="steps step1" v-if="status==1">
			<img src="../../assets/images/addxnwl1.png" class="steps step2" v-if="status==2">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
        <breadcrumb :routerList="[{to:'/chanp/productManage',title:'产品管理'},{title:'产品创建'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon" style="padding-top: 0.38rem;">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail16">
                                        <el-form :model="zy" label-position="right" ref="zy" :rules="rules"
                                                 :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">


                                            <el-form-item label="业务类型" prop="ywlx" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="IN_TYPE" :v="zy.ywlx" v-model="zy.ywlx"></brselect>
                                            </el-form-item>



                                            <!--                                            <el-form-item label="业务类型" class="h-elformWrap-2" prop="ywlx">-->
                                            <!--                                                <el-select v-model="zy.ywlx" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in ywlxxuanxiang"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <!--                                            <el-form-item label="物料型号" class="h-elformWrap-2" prop="wlxh">-->
                                            <!--                                                <el-select v-model="zy.wlxh" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in options1"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <el-form-item label="物料型号" class="h-elformWrap-2" prop="wlxh">
                                                <el-input placeholder="请输入" v-model="zy.wlxh"></el-input>
                                            </el-form-item>

                                            <!--                                            <el-form-item label="基本单位" class="h-elformWrap-2" prop="jbdw">-->
                                            <!--                                                <el-select v-model="zy.jbdw" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in jibendanwei"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <el-form-item label="基本单位" prop="jbdw" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="YLUnit" :v="zy.jbdw" v-model="zy.jbdw"></brselect>
                                            </el-form-item>

                                            <!--										  <el-form-item label="物料描述" class="h-elformWrap-1" prop="wlms">-->
                                            <!--												<el-input v-model="zy.wlms" maxlength="70" placeholder="请填写"></el-input>-->
                                            <!--										  </el-form-item>-->

                                            <!--                                            <el-form-item label="物料组" class="h-elformWrap-2" prop="wlz">-->
                                            <!--                                                <el-select v-model="zy.wlz" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in wuliaozu"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <el-form-item label="物料组" prop="wlz" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <template>
                                                    <brselectlazy category="YLMaterialGroup" :v="zy.wlz" v-model="zy.wlz" ></brselectlazy>
                                                </template>
                                                <!--                                               &lt;!&ndash; todo 模板 &ndash;&gt;-->
                                                <!--                                                <el-select-->
                                                <!--                                                           placeholder="&#45;&#45;选择&#45;&#45;"-->
                                                <!--                                                           style="width:1.5rem"-->
                                                <!--                                                           v-model="zy.wlz"-->
                                                <!--                                                >-->
                                                <!--                                                    <el-option-->
                                                <!--                                                            v-for="(item,index) in YLMaterialGroupList"-->
                                                <!--                                                            :key="index"-->
                                                <!--                                                            :label="item.name"-->
                                                <!--                                                            :value="item.code">-->
                                                <!--                                                    </el-option>-->

                                                <!--                                                </el-select>-->


                                            </el-form-item>






                                            <el-form-item label="旧物料号" class="h-elformWrap-2" prop="jwlh">
                                                <el-input placeholder="请输入" v-model="zy.jwlh"></el-input>
                                            </el-form-item>

                                            <!--                                            <el-form-item label="产品组" class="h-elformWrap-2" prop="cpz">-->
                                            <!--                                                <el-select v-model="zy.cpz" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in chanpinzu"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <el-form-item label="产品组" prop="cpz" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="YLProductGroup" :v="zy.cpz" v-model="zy.cpz"></brselect>
                                            </el-form-item>



                                            <!--                                            <el-form-item label="实验室" class="h-elformWrap-2" prop="sys">-->
                                            <!--                                                <el-select v-model="zy.sys" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in shiyanshi"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->


                                            <el-form-item label="实验室" prop="sys" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="Laboratory" :v="zy.sys" v-model="zy.sys"></brselect>
                                            </el-form-item>


                                            <el-form-item label="外部物料组" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.wbwlz"></el-input>
                                            </el-form-item>


                                            <!--                                            <el-form-item label="税分类" class="h-elformWrap-2" prop="sfl">-->
                                            <!--                                                <el-select v-model="zy.sfl" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in shuifenlei"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <el-form-item label="税分类" prop="sfl" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="YLMtlTaxType" :v="zy.sfl" v-model="zy.sfl"></brselect>
                                            </el-form-item>


                                            <el-form-item label="产品注册号" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cpzch"></el-input>
                                            </el-form-item>
                                            <el-form-item label="储运条件" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cytj"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cd"></el-input>
                                            </el-form-item>

                                            <!--                                            <el-form-item label="产品层次" class="h-elformWrap-2" prop="cpcc">-->
                                            <!--                                                <el-select v-model="zy.cpcc" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in chanpincengci"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <el-form-item label="产品层次" prop="cpcc" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <template>
                                                    <brselectlazy category="YLProdHierarchy" :v="zy.cpcc" v-model="zy.cpcc" ></brselectlazy>
                                                </template>

                                                <!--                                                <el-select-->
                                                <!--                                                        placeholder="&#45;&#45;选择&#45;&#45;"-->
                                                <!--                                                        style="width:1.5rem"-->
                                                <!--                                                        v-model="zy.cpcc"-->
                                                <!--                                                >-->
                                                <!--                                                    <el-option-->
                                                <!--                                                            v-for="(item,index) in YLProdHierarchyList"-->
                                                <!--                                                            :key="index"-->
                                                <!--                                                            :label="item.name"-->
                                                <!--                                                            :value="item.code">-->
                                                <!--                                                    </el-option>-->

                                                <!--                                                </el-select>-->





                                            </el-form-item>

                                            <el-form-item label="生产商" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.scs"></el-input>
                                            </el-form-item>



                                            <!--                                            <el-form-item label="小微编码" class="h-elformWrap-2" prop="xwbm">-->
                                            <!--                                                <el-select v-model="zy.xwbm" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in xiaoweibianma"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->


                                            <el-form-item label="小微编码" prop="xwbm" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="YLXW" :v="zy.xwbm" v-model="zy.xwbm"></brselect>
                                            </el-form-item>


                                            <!--                                            <el-form-item label="生态硬件属性" class="h-elformWrap-2" prop="styjsx">-->
                                            <!--                                                <el-select v-model="zy.styjsx" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in shengtaiyingjianshuxing"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->

                                            <el-form-item label="生态硬件属性" prop="styjsx" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="YLEcology" :v="zy.styjsx" v-model="zy.styjsx"></brselect>
                                            </el-form-item>

                                            <!--                                            <el-form-item label="生态收入" class="h-elformWrap-2" prop="stsr">-->
                                            <!--                                                <el-select v-model="zy.stsr" placeholder="请选择">-->
                                            <!--                                                    <el-option v-for="(item) in shengtaishouru"-->
                                            <!--                                                               :key="item.value"-->
                                            <!--                                                               :label="item.label"-->
                                            <!--                                                               :value="item.value">-->
                                            <!--                                                    </el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->


                                            <el-form-item label="生态收入" prop="stsr" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                                <brselect category="YLEcologyIn" :v="zy.stsr" v-model="zy.stsr"></brselect>
                                            </el-form-item>






                                            <!--										  <el-form-item label="产品有效期(年)" class="h-elformWrap-2" >-->
                                            <!--										  	<el-input placeholder="请输入" v-model="zy.youxiaoqi"></el-input>-->
                                            <!--										  </el-form-item>-->

                                            <el-form-item label="产品有效期" prop="youxiaoqi" :rules="[
								  {required: true, message: '请输入四位整数年份-只能填写正整数', trigger: 'change'},
								]"  class="h-elformWrap-2">

                                                <el-input v-model.number="zy.youxiaoqi" placeholder="请输入四位整数年份"
                                                          oninput="value=value.replace(/[^\d]/g, '')"
                                                          maxlength="4">
                                                </el-input>

                                            </el-form-item>


                                            <!--										  <el-form-item label="凭证" class="h-elformWrap-2" >-->
                                            <!--										  	<el-upload-->
                                            <!--										  	  class="upload-demo"-->
                                            <!--										  	  action="https://jsonplaceholder.typicode.com/posts/"-->
                                            <!--										  	 -->
                                            <!--										-->
                                            <!--										  	  :limit="1"-->
                                            <!--										  	  -->
                                            <!--										  	  :file-list="fileList">-->
                                            <!--										  	  <div class="uploadfile">上传文件</div>-->
                                            <!--										  	</el-upload>-->
                                            <!--										  </el-form-item>-->

                                            <el-form-item label="上传凭证" class="h-elformWrap-1" prop="upload">
                                                <brupload
                                                        :refid="chanpinid"
                                                        :reftype="chanpinziliao"
                                                        uploadflag
                                                        delflag
                                                >
                                                </brupload>
                                            </el-form-item>


                                            <el-form-item label="行业标准描述" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.hybzms"></el-input>
                                            </el-form-item>
                                            <el-form-item label="创建人账号" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cjrzh" disabled="disabled"></el-input>
                                            </el-form-item>


                                            <el-form-item label="驳回审批意见" class="h-elformWrap-2" v-if="chongxintijiaoshow" >
                                                <el-input v-model="zy.shenpiyijian" placeholder="" disabled="disabled"></el-input>
                                            </el-form-item>



                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">

                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="chongxintijiao" v-if="chongxintijiaoshow">重新提交</el-button>

                <el-button class="h-btn h-bBtn h-bgwhite" @click="fanhui">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="zancunortijiao(0)" v-if="!chongxintijiaoshow">保存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="zancunortijiao(1)" v-if="!chongxintijiaoshow">转化真实物料</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    // const cityOptions = ['市场部1', '市场部2', '市场部3', '市场部4'];
    export default {
        data() {
            return {
                // 新手引导页
                showOrhide:false, 
				status:1,
				checked:true,
                toshow:"productCreate",
                chongxintijiaoshow:false,
                //ywid
                ywid:null,
                //instid
                instid:null,
                //taskid
                taskid:null,
                YLProdHierarchyList:[],
                YLMaterialGroupList:[],
                qianyeshuju:{},
                //小微编码
                xiaoweibianma:[{
                    value: '',
                    label: '--请选择--'
                },],
                //生态收入
                shengtaishouru:[{
                    value: '',
                    label: '--请选择--'
                },],
                //生态硬件属性
                shengtaiyingjianshuxing:[{
                    value: '',
                    label: '--请选择--'
                },],

                //产品层次
                chanpincengci:[{
                    value: '',
                    label: '--请选择--'
                },],

                //税分类
                shuifenlei:[{
                    value: '',
                    label: '--请选择--'
                },],

                //实验室
                shiyanshi:[{
                    value: '',
                    label: '--请选择--'
                },],

                //产品组
                chanpinzu:[{
                    value: '',
                    label: '--请选择--'
                },],

                //物料组
                wuliaozu:[{
                    value: '',
                    label: '--请选择--'
                },],

                //基本单位
                jibendanwei:[{
                    value: '',
                    label: '--请选择--'
                },],


                //物料id
                chanpinid: '',

                //资料类型名称
                chanpinziliao: 'shangchuanpingzheng',


                // fileList:[],
                //带线表单
                //   value:false,
                // categorys: '海尔产品',
                // category: ['海尔产品', '竞品'],


                ywlxxuanxiang:[
                    {
                        value: '',
                        label: '--请选择--'
                    },

                    {
                        value: 'SH',
                        label: '上海OEM'
                    }, {
                        value: 'HK',
                        label: '香港OEM'
                    }

                ],




                options1: [{
                    value: '选项1',
                    label: '渠道1'
                }, {
                    value: '选项2',
                    label: '渠道2'
                }],
                options2: [{
                    value: '选项1',
                    label: '分类1'
                }, {
                    value: '选项2',
                    label: '分类2'
                }],
                options3: [{
                    value: '选项1',
                    label: '大类1'
                }, {
                    value: '选项2',
                    label: '大类2'
                }],
                options4: [{
                    value: '选项1',
                    label: '大类1'
                }, {
                    value: '选项2',
                    label: '大类2'
                }],
                options5: [{
                    value: '选项1',
                    label: '型号1'
                }, {
                    value: '选项2',
                    label: '型号2'
                }],
                zy: {
                    ywlx: null,
                    wlxh: null,
                    wlms: null,
                    jbdw: null,
                    wlz: null,
                    jwlh: null,
                    cpz: null,
                    sys: null,
                    wbwlz: null,
                    sfl: null,
                    cpzch: null,
                    cytj: null,
                    cd: null,
                    cpcc: null,
                    scs: null,
                    xwbm: null,
                    styjsx: null,
                    stsr: null,
                    youxiaoqi: null,
                    pingzheng: null,
                    hybzms: null,
                    cjrzh: null,
                    shenpiyijian:null,
                },
                // cities: cityOptions,
                rules: {
                    ywlx: [
                        {required: true, message: '请选择业务类型', trigger: 'blur'}
                    ],
                    wlxh: [
                        {required: true, message: '请选择物料型号', trigger: 'blur'}
                    ],
                    wlms: [
                        {required: true, message: '请输入物料描述', trigger: 'blur'}
                    ],
                    jbdw: [
                        {required: true, message: '请选择基本单位', trigger: 'blur'}
                    ],
                    wlz: [
                        {required: true, message: '请选择物料组', trigger: 'blur'}
                    ],
                    jwlh: [
                        {required: true, message: '请输入旧物料号', trigger: 'blur'}
                    ],
                    sfl: [
                        {required: true, message: '请选择税分类', trigger: 'blur'}
                    ],
                    cpcc: [
                        {required: true, message: '请选择产品层次', trigger: 'blur'}
                    ]
                }
            }
        },


        //加载页面默认执行
        created() {
			this.showzhezhao()

            // //获取字典max
            // ss.Dictservice.maxlistbyCategory("YLMaterialGroup").then(rd=>{
            //     console.log(rd,'????')
            //
            //     this.YLMaterialGroupList = rd;
            //
            // })
            //
            // //获取字典max
            // ss.Dictservice.maxlistbyCategory("YLProdHierarchy").then(rd=>{
            //     console.log(rd,'????')
            //
            //     this.YLProdHierarchyList = rd;
            //
            // })
            //
            //
            //


            if(this.$router.history.current.query.xuniwuliao!=null){

                //前页数据
                this.qianyeshuju = this.$router.history.current.query;

                this.chanpinid = this.$router.history.current.query.xuniwuliao;

                var chushucanshu1 = {

                    materialCode:this.$router.history.current.query.materialCode,
                    xuniwuliao:this.$router.history.current.query.xuniwuliao,
                    rowId:this.$router.history.current.query.rowId,

                };

                //获取信息
                this.gettableels(chushucanshu1);

                //若有驳回内容
            }else if(this.$route.query.ywid){

                this.chongxintijiaoshow = true;

                //ywid
                this.ywid = this.$route.query.ywid;

                //instid
                this.instid = this.$route.query.instid;

                //taskid
                this.taskid = this.$route.query.taskid;

                //产品id
                this.chanpinid = this.ywid;


                var chushucanshu2 = {

                    xuniwuliao:this.$route.query.ywid,

                };

                //获取信息
                this.gettableels(chushucanshu2);


            }else{

                //一打开新建页面就先给上一个新的uuid作为物料编码
                this.chanpinid = this.$util.getUuid();


            }


            //加载登陆人账号
            this.zy.cjrzh = this._user.usercode;


            //加载配置项
            this.huoquprizhixiang();

        },


        //监听
        watch: {},


        methods: {


            //重新提交
            chongxintijiao(){

                //更新修改的信息
                this.zancunortijiao(3);

                var chongxin = {

                    yewuzhujian:this.ywid,
                    taskid:this.taskid,

                }

                //重新提交
                ss.chanpin.chongxintijiao(chongxin).then(rd => {

                    if(rd.obj==true){

                        this.$msg.msgs(rd.msg)

                        //返回
                        this.$router.push({path: '/chanp/productManage'});

                    }

                })


            },



            //加载配置项
            gettableels(q) {

                ss.chanpin.idaorrowIdbselectList(q).then(rd => {

                    console.log(rd.obj,'???,,,???')

                    this.vw = rd.obj;

                    var ss = {
                        ywlx: rd.obj.oemType||'',//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
                        wlms: rd.obj.materialDescrition||'',// 物料描述   //产品型号
                        jbdw: rd.obj.primaryUom||'',//基本计量单位
                        wlz: rd.obj.materialGroupCode||'',//物料组
                        jwlh: rd.obj.oldMaterialNumber||'',// 旧物料号
                        cpz: rd.obj.department||'',//产品组
                        sys: rd.obj.labStudio||'',//实验室/办公室
                        wbwlz: rd.obj.extMtlGroup||'',//外部物料组
                        sfl: rd.obj.tax||'',//税分类
                        cpzch: rd.obj.productRegNum||'',//产品注册号
                        cytj: rd.obj.shipCondition||'',//储运条件
                        cd: rd.obj.placeOrigin||'',//产地
                        cpcc: rd.obj.productHierarchy||'',//产品层次  (关联产品层级编码id)
                        scs: rd.obj.manufacturer||'',//生产商
                        xwbm: rd.obj.zattr5u||'',//小微编码
                        styjsx: rd.obj.ecology||'',//生态硬件属性
                        stsr: rd.obj.ecologyIn||'',//生态收入
                        youxiaoqi: rd.obj.zcpyxq||'',//产品有效期(年)
                        hybzms: rd.obj.industryStdDesc||'',//行业标准描述
                        cjrzh: rd.obj.cucode||'',//创建人编码
                        wlxh: rd.obj.materialDescrition||'',// 物料描述   //产品型号
                        shenpiyijian:rd.obj.zhenshishenpijindu==null?'':rd.obj.zhenshishenpijindu.split("_")[2]||'',//审批意见

                    }

                    this.zy = ss;


                })

            },




            // selectC(item) {
            //      this.categorys = item;
            //      console.log(this.categorys)
            //  },
            //  add1(){
            //      var list = {
            //          times: '',
            //          code:'',
            //          names: '',
            //          styles: '',
            //          nums: '',
            //          yixiang: '',
            //          beizhu:''
            //      }
            //      this.tableData3.push(list)
            //  },
            //  add2(){
            //      var list = {
            //          times: '',
            //          code:'',
            //          names: '',
            //          styles: '',
            //          nums: '',
            //          yixiang: '',
            //          beizhu:''
            //      }
            //      this.tableData4.push(list)
            //  },


            zancunortijiao(q) {


                this.$refs['zy'].validate((valid) => {
                    if (valid) {

                        var canshu = {

                            id: this.chanpinid,//虚拟物料id
                            materialCode: this.chanpinid,// 真实物料id里先也存一个虚拟物料id
                            oemType: this.zy.ywlx,
                            materialDescrition: this.zy.wlxh,
                            primaryUom: this.zy.jbdw,
                            materialGroupCode: this.zy.wlz,
                            oldMaterialNumber: this.zy.jwlh,
                            Department: this.zy.cpz,
                            labStudio: this.zy.sys,
                            extMtlGroup: this.zy.wbwlz,
                            Tax: this.zy.sfl,
                            productRegNum: this.zy.cpzch,
                            shipCondition: this.zy.cytj,
                            placeOrigin: this.zy.cd,
                            productHierarchy: this.zy.cpcc,
                            manufacturer: this.zy.scs,
                            zattr5u: this.zy.xwbm,
                            ecology: this.zy.styjsx,
                            ecologyIn: this.zy.stsr,
                            zcpyxq: parseInt(this.zy.youxiaoqi),
                            industryStdDesc: this.zy.hybzms,
                            cucode: this.zy.cjrzh,
                            chongxintijiao:q==3?1:null,//3是重新提交

                        }


                        if (q == 0) {//暂存

                            this.zancun(canshu);

                        } else {//提交

                            this.querentijiao(canshu);

                        }


                    } else {
                        console.log('error submit!!');
                        return false;
                    }



                });

            },


            //获取配置项
            huoquprizhixiang(){

                // var canshu = [
                //
                //     'YLEcology',//生态硬件属性
                //     'YLMaterialGroup',//生物医疗物料组清单
                //     'YLProductGroup',//生物医疗产品组清单
                //     'YLUnit',//生物医疗基本单位清单
                //     'YLXW',//生物医疗小微
                //     'Laboratory',//实验室
                //     'YLProdHierarchy',//生物医疗产品层次
                //     'YLMtlTaxType',//税分类
                //     'YLEcologyIn',//生态收入
                //
                // ];
                //
                //
                // ss.chanpin.peizhiselectList(canshu).then(rd => {
                //
                //     this.configlist = rd.obj;
                //
                //     //加载基本单位
                //     for(var r in rd.obj.YLUnit){
                //
                //         var tt = {
                //             value: rd.obj.YLUnit[r].value,
                //             label: rd.obj.YLUnit[r].valueMeaning,
                //         }
                //
                //         this.jibendanwei.push(tt);
                //
                //     }
                //
                //     //加载基本单位
                //     for(var r in rd.obj.YLMaterialGroup){
                //
                //         var tt = {
                //             value: rd.obj.YLMaterialGroup[r].value,
                //             label: rd.obj.YLMaterialGroup[r].valueMeaning,
                //         }
                //
                //         this.wuliaozu.push(tt);
                //
                //     }
                //
                //
                //     //加载产品组
                //     for(var r in rd.obj.YLProductGroup){
                //
                //         var tt = {
                //             value: rd.obj.YLProductGroup[r].value,
                //             label: rd.obj.YLProductGroup[r].valueMeaning,
                //         }
                //
                //         this.chanpinzu.push(tt);
                //
                //     }
                //
                //
                //     //加载实验室
                //     for(var r in rd.obj.Laboratory){
                //
                //         var tt = {
                //             value: rd.obj.Laboratory[r].value,
                //             label: rd.obj.Laboratory[r].valueMeaning,
                //         }
                //
                //         this.shiyanshi.push(tt);
                //
                //     }
                //
                //
                //     //加载税分类
                //     for(var r in rd.obj.YLMtlTaxType){
                //
                //         var tt = {
                //             value: rd.obj.YLMtlTaxType[r].value,
                //             label: rd.obj.YLMtlTaxType[r].valueMeaning,
                //         }
                //
                //         this.shuifenlei.push(tt);
                //
                //     }
                //
                //
                //     //加载产品层次
                //     for(var r in rd.obj.YLProdHierarchy){
                //
                //         var tt = {
                //             value: rd.obj.YLProdHierarchy[r].value,
                //             label: rd.obj.YLProdHierarchy[r].valueMeaning,
                //         }
                //
                //         this.chanpincengci.push(tt);
                //
                //     }
                //
                //
                //     //加载生态硬件属性
                //     for(var r in rd.obj.YLEcology){
                //
                //         var tt = {
                //             value: rd.obj.YLEcology[r].value,
                //             label: rd.obj.YLEcology[r].valueMeaning,
                //         }
                //
                //         this.shengtaiyingjianshuxing.push(tt);
                //
                //     }
                //
                //
                //     //加载生态收入
                //     for(var r in rd.obj.YLEcologyIn){
                //
                //         var tt = {
                //             value: rd.obj.YLEcologyIn[r].value,
                //             label: rd.obj.YLEcologyIn[r].valueMeaning,
                //         }
                //
                //         this.shengtaishouru.push(tt);
                //
                //     }
                //
                //
                //     //加载小微编码
                //     for(var r in rd.obj.YLXW){
                //
                //         var tt = {
                //             value: rd.obj.YLXW[r].value,
                //             label: rd.obj.YLXW[r].valueMeaning,
                //         }
                //
                //         this.xiaoweibianma.push(tt);
                //
                //     }
                //
                //
                //
                //
                //
                //
                // })



            },


            querentijiao(q) {

                ss.chanpin.addtijiao(q).then(rd => {

                    if(q.chongxintijiao==null){

                        this.$msg.msgs(rd.msg);

                        this.fanhui();

                    }

                })

            },


            zancun(q) {

                ss.chanpin.addzancun(q).then(rd => {

                    this.$msg.msgs(rd.msg);

                    this.fanhui();

                    this.chanpinid = rd.obj.xuniwuliao;

                    var ss = {

                        ywlx: rd.obj.oemType,
                        wlxh: rd.obj.materialDescrition,
                        jbdw: rd.obj.primaryUom,
                        wlz: rd.obj.materialGroupCode,
                        jwlh: rd.obj.oldMaterialNumber,
                        cpz: rd.obj.department,
                        sys: rd.obj.labStudio,
                        wbwlz: rd.obj.extMtlGroup,
                        sfl: rd.obj.tax,
                        cpzch: rd.obj.productRegNum,
                        cytj: rd.obj.shipCondition,
                        cd: rd.obj.placeOrigin,
                        cpcc: rd.obj.productHierarchy,
                        scs: rd.obj.manufacturer,
                        xwbm: rd.obj.zattr5u,
                        styjsx: rd.obj.ecology,
                        stsr: rd.obj.ecologyIn,
                        youxiaoqi: rd.obj.zcpyxq,
                        hybzms: rd.obj.industryStdDesc,
                        cjrzh: rd.obj.cucode

                    }

                    this.zy = ss;


                })


            },


            //返回上一页
            fanhui() {

                this.$router.push({path: '/chanp/productManage'});

            },
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
				if(this.status ==1){
					document.documentElement.scrollTop = 200;
					this.status = 2;
				}else if(this.status ==2){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			}

        },
		mounted() {

		}
    }
</script>

<style scoped>



</style>
<style>
    .weekplandetail16 .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }
    .weekplandetail16 .h-formbLine .el-form-item__content {
        width: 69%;
    }
    .weekplandetail16 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }
	.weekplandetail16 .h-formbLine .h-elformWrap-1 .el-form-item__label{
	    width: 10%;
	}
	.weekplandetail16 .h-formbLine .h-elformWrap-1 .el-form-item__content{
	    width: 90%;
	}
    .weekplandetail16 .h-formbLine .el-form-item__content .el-select{
        width:100%!important;
    }
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top:1.75rem;
			left: 3rem;
			width: 15.5rem;
			height: 6.5rem;
		}
		.step2{
			top: 7.2rem;
			right: 1.5rem;
			width: 8rem;
			height: 1.5rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
